import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutGrid } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const MORE = { es: 'Más', en: 'More', de: 'Mehr' };

const Header = () => {
  const { language } = useLanguage();
  const { pathname } = useLocation();
  if (/^\/(place|trail|article|itinerary)\//.test(pathname)) return null;

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-gray-100/50 safe-top" data-testid="header">
      <div className="relative flex items-center justify-center h-14">
        <Link to="/" className="flex items-center gap-1" data-testid="logo">
          <span className="font-semibold text-lg text-[#1A202C]">Calma Guide Tenerife</span>
        </Link>
        <Link
          to="/more"
          className="hidden md:flex absolute right-4 items-center gap-1.5 text-sm font-medium text-gray-500 hover:text-[#38B2AC] transition-colors"
          data-testid="header-more-link"
        >
          <LayoutGrid size={16} /> {MORE[language] || MORE.es}
        </Link>
      </div>
    </header>
  );
};

export default Header;
